<ng-container *ifScreenSize="screenType.Mobile">
  <ng-container *notInPopulation="[populations.Suite, populations.Pts]">
    <fgb-page-header [pageTitle]="'challenges.page.title'" [backButtonLink]="'/'"></fgb-page-header>
    <fgb-banner [title]="'challenges.page.title' | translate"></fgb-banner>

    <div class="container">
      <fgbcl-badge-achieved />
    </div>

    <div class="scorecard-list-container">
      <fgbcl-scorecard-list-view
        [isSponsorInBody]="false"
        [icon]="'chevron_right'"
        [showPlaceholder]="true"
      ></fgbcl-scorecard-list-view>
    </div>
  </ng-container>

  <ng-container *inPopulation="[populations.Suite, populations.Pts]"><fgb-not-found-page></fgb-not-found-page></ng-container>
</ng-container>

<ng-container *ifScreenSize="screenType.Desktop">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
